module.exports = __webpack_public_path__ + "static/media/logo_epics.ae364529.png";